module.exports = __webpack_public_path__ + "img/9788959760251.56f65ee2.jpg";